import styled from '@emotion/styled';

export const InfoContainer = styled.div`
  font-size: 9px;
  color: ${({ theme }: any) => theme.palette?.primary.main};
  padding: 5px 10px;
  position: absolute;
  bottom: 0;
`;
